<template>
  <div class="order-sidebar-container">
    <div class="d-flex justify-content-end">
      <router-link class="order_link" v-if="isOrder" :to="{ path: '/user/trade/order-history'}">
        <b-button class="list-btn" size="sm" variant="success"><i class="fas fa-link" /> {{ $tc('order.order', 2) }}</b-button>
      </router-link>
      <router-link class="order_link" v-else :to="{ path: '/user/trade/trade-history'}">
        <b-button :disabled="tradeBtnDisable" class="list-btn" size="sm" variant="success">{{ $tc('order.history', 2) }}</b-button>
      </router-link>
    </div>
    <ul class="history-wrapper" ref="menu-list" id="menu-list">
      <div v-if="!items || !(items && items.length > 0)" class="item text-14 text-gray text-center">
        <hr/>
        <i class="far fa-file" />
        {{ $t('helper.empty') }}
      </div>
      <li v-for="(item, i) in items" :key="i" class="item animate__animated animate__flipInX" :class="getOrderVariant(item)">
        <div class="history-item" @click="showOrderTrDetail(item)" :v-b-tooltip.bottom="item.sent === 2" :title="item.sent === 2 && $t('order.pending')">
          <div class="date">
            <span>
              {{ item.created_at | formatDate('date') }}
            </span>
            <span class="time">
              {{ item.created_at | formatDate('time') }}
            </span>           
          </div>
          <div class="symbol">
            <span class="name">
              {{ toSymbolName(item.symbol) }}
            </span>
            <!-- <span class="type"> -->
            <!--   {{ item.order_type === 2 ? $t('brand.type.conditional') : $t('brand.type.current') }} / {{ $t('order.state.' + item.exec_type) }} -->
            <!-- </span> --> 
            <span class="type">
              {{ item.side === 1 ? $t('order.buy-short') : $t('order.sell-short') }} / {{ $t('order.state.' + item.exec_type) }}
            </span>
          </div>
          <div class="info">
            <div class="info_row">
              <span></span> 
              <!-- <span class="unit">{{ calculateAvgPrice(item) | currency('', '₮') }}</span> --> 
              <span class="unit" v-if="item.order_type !== 2">{{ this.averagePrice | currency('', '₮') }}</span>
              <span class="unit" v-else>{{ item.unit_price | currency('', '₮') }}</span>
            </div>
            <div class="info_row">
              <span></span>
              <span class="unit">
                {{ item.quantity | amount }}
              </span>
            </div>
          </div>

          <!-- <div class="short-info"> -->
          <!--   <div> -->
          <!--     <span> -->
          <!--       {{ item.created_at | formatDate('date') }} -->
          <!--     </span> -->
          <!--     <span> -->
          <!--       {{ item.created_at | formatDate('time') }} -->
          <!--     </span> -->
          <!--   </div> -->
          <!--   <div> -->
          <!--     <strong>{{ item.unit_price | currency('', '₮') }} x {{ item.quantity | amount }}</strong> -->
          <!--   </div> -->
          <!-- </div> -->
          <!-- <div class="additional-info"> -->
          <!--   <div> -->
          <!--     <i class="fas fa-clock"></i> {{ item.created_at }} -->
          <!--   </div> -->
          <!--   <div> -->
          <!--     <i class="fas fa-balance-scale"></i> {{ item.order_type === 2 ? 'Нөхцөлт' : 'Зах зээлийн' }} -->
          <!--   </div> -->
          <!-- </div> -->
        </div>
        <!-- <b-row> -->
        <!--   <b-col class="text-right" cols="4" id="time-only">{{ item.created_at | formatDate('time') }}</b-col> -->
        <!--   <b-col class="text-center" cols="4"> -->
        <!--     <h5>{{ toSymbolName(item.symbol) }}</h5> -->
        <!--   </b-col> -->
        <!-- <b-col class="text-left"> -->
        <!-- <b-badge class="state-badge" v-if="item.exec_type" pill :variant="ExecType[item.exec_type].variant">{{ ExecType[item.exec_type].name }}</b-badge> -->
        <!-- {{ ExecType[item.exec_type].variant }} -->
        <!-- </b-col> -->
        <!-- </b-row> -->
        <!-- <b-row> -->
        <!--   <b-col class="text-right" cols="4">{{ item.created_at | formatDate('date') }}</b-col> -->
        <!--   <b-col cols="8"><p>{{ item.unit_price | currency('', '₮') }} x {{ item.quantity | amount }}</p></b-col> -->
        <!-- </b-row> -->
        <!-- <b-row> -->
        <!-- <b-col cols="4" class="text-right"> -->
        <!--   <b-badge :variant="item.order_type === 1 ? 'info' : 'dark'">{{ item.order_type === 2 ? 'Нөхцөлт' : 'Зах зээлийн' }}</b-badge> -->
        <!-- </b-col> -->

        <!-- <b-col cols="4"> -->
        <!--   <b-button class="show-more-button" @click="showOrderTrDetail(item)" variant="outline-info">Дэлгэрэнгүй</b-button> -->
        <!-- </b-col> -->
        <!-- <b-col cols="4" class="text-left"><b-button v-if="isOrder" v-b-tooltip.top class="cancel-button" :disabled="isCancelDisabled(item)" variant="outline-danger" size="sm" title="Цуцлах" @click="cancelOrder(item)"><span><i class="fas fa-trash"></i></span></b-button></b-col> -->
        <!-- </b-row> -->
      </li>
      <!-- <li v-show="isLoading" class="item spinner-wrapper justify-content-center"> -->
      <!--   <span class="loading-spinner"><i class="fas fa-spinner"></i></span> -->
      <!-- </li> -->
    </ul>
    <b-modal
      id="order-tr-detail-modal"
      size="lg"
      hide-footer
      hide-header
      :body-bg-variant="bodyBgVariant"
      :body-text-variant="bodyTextVariant"
      >
      <div class="d-flex"  v-if="selectedDetail">
        <order-info :isOrder="isOrder" :selectedDetail="selectedDetail" :cancelOrder="cancelOrder" />
      </div> 
      <div class="pt-4" v-if="selectedDetail.order_details && selectedDetail.order_details.length">
        <label>{{ isOrder ? $tc('order._order', 2) : $tc('order._history', 2) }} {{ $t('helper.more') }}</label>
        <table class="default-table">
          <thead>
            <th class="text-center">{{ $t('order.index') }}</th>
            <th class="text-center">{{ $t('order.price') }}</th>
            <th class="text-center">{{ $t('order.quantity') }}</th>
            <th class="text-center">{{ $t('order.remaining') }}</th>
            <th class="text-center">{{ $t('order.fee') }}</th>
            <th class="text-center">{{ $t('order.created_at') }}</th>
          </thead>
          <tbody v-for="(detail, i) in selectedDetail.order_details" :key="i">
            <td class="text-center" :variant="detail.text ? 'danger' : ''">{{ i + 1 }}.</td>
            <td class="text-center" v-if="!detail.text">{{ detail.last_px }}</td>
            <td class="text-center" v-if="!detail.text">{{ detail.last_qty }}</td>
            <td class="text-center" v-if="!detail.text">{{ detail.leaves_qty }}</td>
            <td class="text-center" v-if="!detail.text">{{ detail.fee || '-' }}</td>
            <td class="text-center" v-if="!detail.text">{{ detail.created_at | formatDate }}</td>
            <td class="text-center" v-else colspan="4" variant="danger">{{ detail.text }}</td>
          </tbody>
        </table> 
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import api from '../../api/stoTrade';
import { ExecType } from '../../constants';
import { mapActions, mapState } from 'vuex';
import OrderInfo from '../../components/OrderInfo';

export default {
  name: 'OrderTradeHistory',
  props: {
    isOrder: {
      required: false,
      type: Boolean
    }
  },
  data() {
    return {
      ExecType,
      isLoading: false,
      items: [],
      selectedDetail: {},
      page: 1,
      HistoryLastPage: 1,
    };
  },
  components: {
    'order-info': OrderInfo,
  },
  mounted() {
    this.page = 0;
    // const listElm = document.querySelector('#menu-list');
    const listElm = this.$refs['menu-list'];
    if (listElm) {
      listElm.addEventListener('scroll', () => {
        if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          setTimeout(() => {
            this.page += 1;
            if (this.page <= this.HistoryLastPage) this.fetchData();
          }, 400);
        }
      });
    } 
    this.fetchData();

    // this.$bvModal.show('order-tr-detail-modal');
  },
  beforeDestroy() {
    // const elm = document.querySelector('#menu-list');
    // console.log(elm);
    this.$refs['menu-list'].removeEventListener('scroll', () => {});
    // elm.removeEventListener('scroll', () => {});
  },
  methods: {
    getOrderVariant(item) {
      return 'order-' + ExecType[item.exec_type].variant;
    },
    isCancelDisabled(brand) {
      // return (brand.sent === 3 && brand.exec_type === 'F') || this.disabledList.includes(brand.exec_type);
      return false
    },
    cancelOrder(item) {
      this.$swal({
        icon: 'warning',
        title: `${this.toSymbolName(item.symbol)} | ${this.$options.filters.currency(item.unit_price, '', '₮')} x ${this.$options.filters.amount(item.quantity)}`,
        text: this.$t('helper.cancel-title', {slot: this.$tc('order._order', 1)}),
        confirmButtonText: this.$t('helper.cancel'),
        confirmButtonColor: '#ff7674',
        cancelButtonColor: '#c3c3c3',
        cancelButtonText: this.$t('helper.refuse'),
        showCancelButton: true,
        showConfirmButton: true,
        reverseButtons: false,
      }).then(async ({ dismiss, value }) => {
        if (!dismiss && !!value) {
          this.isLoading = true;
          try {
            await api.cancelOrder(item);
            await this.fetchData();
            this.$bvToast.toast(this.$t('helper.cancel-success'), { title: this.$t('helper.success'), variant: 'info' });
          } catch (e) {
            console.error(e);
          }
          this.isLoading = false;
        }
      }).catch((err) => { console.error(err); });
    },
    showOrderTrDetail(data) {
      this.selectedDetail = data;
      this.$bvModal.show('order-tr-detail-modal');
    },
    async fetchData() {
      this.isLoading = true;
      try {
        const { data: { data, ...page } } = this.isOrder ? await api.orderHistory({ page: this.page }) : await api.tradeHistory({ page: this.page });
        this.HistoryLastPage = page && page.last_page;
        this.items.push(...data);
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
    toSymbolName(symbol) {
      if (!symbol) return;
      return !symbol.split('').includes('-') ? symbol : symbol.split('').splice(0, symbol.split('').findIndex(x => x === '-')).join('').toString();
    },
    calculateAvgPrice(order) {
      let averagePrice = 0;
      let total = 0;
      order.order_details.forEach(item => {
        averagePrice += parseFloat(item.last_px) * parseFloat(item.last_qty);
        total += parseFloat(item.last_qty);
      });
      averagePrice /= total;
      return averagePrice > 0 ? averagePrice : 0;
    }
  },
  computed: {
    ...mapState('common', ['dark' ]),
    bodyBgVariant() {
      return this.dark ? 'dark' : 'light'
    },
    bodyTextVariant() {
      return this.dark ? 'light' : 'dark'
    },
    disabledList() {
      return ['4', 'C', '8', '6'];
    },
    orderBtnDisable() {
      return this.$route.name === 'order-history' && this.isOrder;
    },
    tradeBtnDisable() {
      return this.$route.name === 'trade-history' && !this.isOrder;
    },
  },
}
</script>

<style lang="scss" src="../../../sass/partials/sidebar-submenu.scss"></style>
